// extracted by mini-css-extract-plugin
export default {"modal":"SendPackageModal_modal__tLUrT"};